export default "__VITE_ASSET__CVIuLaJt__"